export const corporate_workspaces = {
    meta_title: "Corporate Fiber Network Solutions | GPON for Workspaces",
    meta_description:
        "Niurix GPON solutions power corporate workspaces with secure, low-latency fiber connectivity and centralized network control.",

    section1: {
        banner_img: "Corporate Banner",
        banner_img_mobile: "Corporate banner",
        title: "Corporate Workspaces that Work: Reimagine Connectivity Solutions for Modern Workforce.",
    },
    section2: {
        img: "CORPORATE WORKSPACES1",
        title: "Connecting buildings to fiber; <span>easy, reliable and fast.</span>",
        subtitle: "Lorem_Subtitle",
        desc: "High data protection, improved performance, low latency, and reliable, experience all of this in a Niurix powered fiber optic workspace. Conduct video conferencing, cloud computing, and access real-time data within seconds.",
    },

    section3: [
        {
            device_img: "ISP Router",
            device_title: "Router",
        },

        {
            device_img: "olt",
            device_title: "OLT",
        },

        {
            device_img: "Splitter",
            device_title: "Splitter",
        },

        {
            device_img: "Internet traffic",
            device_title: "Internet traffic",
        },

        {
            device_img: "1G Fiber",
            device_title: "1G Fiber",
        },

        {
            device_img: "Ethernet cable",
            device_title: "Ethernet cable",
        },

        {
            device_img: "ONT",
            device_title: "ONT",
        },

        {
            device_img: "IPTV",
            device_title: "IPTV",
        },

        {
            device_img: "Router",
            device_title: "Access Point",
        },

        {
            device_img: "telephone",
            device_title: "telephone",
        },

        {
            device_img: "wireless",
            device_title: "Wireless",
        },
    ],
    section4: {
        title: "Advantages of Niurix Corporate Workforce Solutions",
        desc: "A fast-running internet connection is like blood for any workspace. Niurix's FTTD (Fiber to the Desk) solution offers technologically advanced and aesthetically pleasing workspace where enhanced productivity is the result of uninterrupted communication and data flow.",
        cards: [
            {
                cards_img: "Integration-with-External-Networks",
                cards_title: "Integration with External Networks",
                // cards_desc: "Supports all data carrying devices like surveillance cameras, routers, switches, etc. to create one network that connects all.",
            },

            {
                cards_img: "Seamlessly-Connected",
                cards_title: "Seamlessly Connected",
                // cards_desc: "Connection, configuration and credential sharing is done to ethernet or wireless devices easily.",
            },

            {
                cards_img: "Gigabit Level Network Velocity",
                cards_title: "Gigabit Level Network Velocity",
                // cards_desc: "Low latency, high speed network anytime to support high bandwidth applications compared to copper-based network.",
            },

            {
                cards_img: "Designed-to-Maximize-Performance",
                cards_title: "Designed to Maximize Performance",
                // cards_desc: "Deliver enterprise-class solution, enabling deployments in even the most challenging network environments.",
            },
        ],
    },
    section5: {
        img: "contact banner",
        title: "Lorem",
    },
};
